import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export const ThankYouTemplate = ({ emailData }) => {
  const [tahnkhead, setThankhead] = useState("");
  const navigate = useNavigate();
  // const location = useLocation(); // Use the useLocation hook
  // const isBookingForm = location.pathname.includes("/rooms/");

  const currentUrl = window.location.pathname;
  console.log("currentUrl", currentUrl);

  useEffect(() => {
    if (currentUrl.includes("contact")) {
      setThankhead("contact");
    } else {
      setThankhead("Booking");
    }
  });
  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <>
      <div className="container py-4">
        <div className="card py-4 text-center">
          <h1 className="heading">Thank You for {tahnkhead} with us! </h1>
          <p className="message">
            Our customer service reception will contact you shortly ASAP for
            further process.
          </p>
          <div className="col-12">
            <div className="row">
              <div className="col-md-6 col-sm-12 py-2">
                <NavLink to={"/"}>
                  <button
                    // className="btn btn-primary-custom col-md-6 col-sm-12"
                    className="btn
                  btn-primary-custom
                  py-md-3
                  px-md-5
                  me-3
                  animated
                  slideInLeft"
                    onClick={handleBackToHome}
                  >
                    Back to Home
                  </button>
                </NavLink>
              </div>
              <div className="col-md-6 col-sm-12 py-2">
                <NavLink to={"/rooms"}>
                  <button
                    // className="btn btn-dark-custom col-md-6 col-sm-12"
                    className="btn btn-dark-custom py-md-3 px-md-5 animated slideInRight"
                  >
                    Back to Booking
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
